import { handleApiRequest } from '../services/transports';

import { REACT_APP_RSD_DOMAIN } from './base';

export const stockMatchUpload = form => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/StockMatch/sop-match-stock`,
  method: 'post',
  form
});

export const stockMatchListing = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/StockMatch/sop-stock-matched-items`,
  method: 'get',
  query
});

export const acceptStockMatch = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}system-management/api/portal/Notification/accept-stock-matched-batchs`,
  method: 'post',
  data
});

export const dispatchStockMatch = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}system-management/api/portal/Notification/stock-match-dispatch-notification-batch`,
  method: 'post',
  data
});

export const transferStockMatch = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}system-management/api/portal/Notification/stock-match-transfer-notification-batch`,
  method: 'post',
  data
});

export const pendingPackagesStockMatchedItems = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/StockMatch/sop-pending-packages`,
  method: 'get',
  query
});

export const sopStockMatchLogList = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/StockMatch/sop-stock-match-history-listing`,
  method: 'get',
  query
});

export const sopStockMatchLogDetails = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/StockMatch/sop-stock-match-history-details`,
  method: 'get',
  query
});

export const sopStockMatchLogDetailsExcel = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/StockMatch/sop-stock-match-history-details-excel`,
  method: 'get',
  query
});

export const smpStockMatchLogList = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/StockMatch/smp-stock-match-history-listing`,
  method: 'get',
  query
});

export const smpStockMatchLogDetails = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/StockMatch/smp-stock-match-history-details`,
  method: 'get',
  query
});

export const smpStockMatchLogDetailsExcel = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/StockMatch/smp-stock-match-history-details-excel`,
  method: 'get',
  query
});

export const mpStockMatchLogList = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/StockMatch/mp-stock-match-history-listing`,
  method: 'get',
  query
});

export const mpStockMatchLogDetails = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/StockMatch/mp-stock-match-history-details`,
  method: 'get',
  query
});

export const mpStockMatchLogDetailsExcel = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/StockMatch/mp-stock-match-history-details-excel`,
  method: 'get',
  query
});

export const getStockMatchUiControls = () => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/StockMatch/sop-stock-match-ui-controls`,
  method: 'get'
});

export const getStockMatchRedistributionStatistics = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/StockMatch/sop-stock-match-redistribution-statstics`,
  method: 'get',
  query
});

export const getStockMatchCardStatistics = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/StockMatch/sop-stock-match-card-statstics`,
  method: 'get',
  query
});

export const getStockMatchUnmetDemandsCount = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/StockMatch/sop-stock-match-unmet-demands-count`,
  method: 'get',
  query
});

export const getStockMatchRedistributionOpportunities = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/StockMatch/sop-stock-match-redistribution-opportunities`,
  method: 'get',
  query
});

export const getStockMatchRedistributionBatchDetails = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/StockMatch/sop-stock-match-redistribution-batch-details`,
  method: 'get',
  query
});

export const getStockMatchRedistributionBatchesList = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/StockMatch/sop-stock-match-redistribution-batches-list`,
  method: 'get',
  query
});

export const getStockMatchRedistributionExpiryPriorityLookup = () => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/StockMatch/sop-stock-match-redistribution-expiry-priority-lookup`,
  method: 'get'
});

export const getStockMatchRedistributionDemandRequests = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/StockMatch/sop-stock-match-unmet-demands-list`,
  method: 'get',
  query
});

export const getPharmacyStockMatchMarketOpportunities = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/StockMatch/sop-stock-match-redistribution-market-Opportunity`,
  method: 'get',
  query
});

export const getPharmacyStockMatchMyOpportunities = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/StockMatch/sop-stock-match-redistribution-my-opportunities`,
  method: 'get',
  query
});

export const getPharmacyStockMatchMyEstablishmentStock = () => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/StockMatch/sop-stock-match-redistribution-my-establishment-stock`,
  method: 'get'
});

export const getPharmacyStockMatchMyOpportunityBatches = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/StockMatch/sop-stock-match-redistribution-my-opportunity-batches`,
  method: 'get',
  query
});
